import { combineReducers } from "@reduxjs/toolkit";
import searchReducer from "./_searchReducer";
import sessionReducer from "./_sessionReducer";
import uiReducer from "./_uiReducer";

const reducer = combineReducers({
  searchContext: searchReducer,
  sessionContext: sessionReducer,
  uiContext: uiReducer,
});

export default reducer;
